$(document).on('ready', function () {
    if (typeof Masonry !== 'undefined') {
        $('.js-masonry').each(function () {
            var $t = $(this);
            var masonryOptions = {
                columnWidth : $t.width() / 2,
                transitionDuration: 0
            };
            var resizeTimeout;

            $t.data('masonry', $t.masonry(masonryOptions));

            $(document).on('tabchange', function (e) {
                if (typeof $t.data('masonry') !== 'undefined') {
                    $t.masonry(masonryOptions);
                }
            });

            $(window).on('resize', function () {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(function () {
                    if (typeof $t.data('masonry') !== 'undefined') {
                        $t.masonry(masonryOptions);
                    }
                }, 200); // на мобильнике ломается из-за скрытия панелей браузера при прокрутке, поэтому нужен таймаут
            });
        });
    }
});
